import queryString from "query-string";

export const parseLang = query => {
  return query ? queryString.parse(query).lang || "fi" : "fi";
};

export const constructApiUrl = (baseUrl, query) => {
  const base = baseUrl.split("?");
  const queries = base[1] ? `?${base[1]}&${query}` : `?${query}`;
  return `${base[0]}${queries}`;
};

export const appendLocale = (path, locale, query) => {
  const url = [path];
  const localeObj = locale === "fi" ? {} : { lang: locale };
  const { lang, ...currentQuery } = queryString.parse(query);
  const queryWithLocale = {
    ...currentQuery,
    ...localeObj
  };
  const queryStringified = queryString.stringify(queryWithLocale);
  if (queryStringified) {
    url.push(queryStringified);
  }
  return url.join("?");
};

// Validation for search term (default minimum of 3).
export const isTermValid = (term, minLength) => {
  if (term === undefined) return false;
  if (minLength === undefined) minLength = 3;
  return term.trim().length >= minLength;
};

// Validation for search terms (separator being comma, default minimum of 3)
export const isTermListValid = (terms, minLength) => {
  if (terms === undefined) return false;
  if (minLength === undefined) minLength = 3;
  let searchTerms = terms.trim().split(',');
  return searchTerms.some(searchTerm => isTermValid(searchTerm, minLength));
};


// WEBPACK FOOTER //
// ./src/utils.js